exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barra-negra {\n  background-color: #000;\n  padding: 2.5rem 0;\n}\n.elemento-centrado {\n  margin: 0 auto;\n  display: block;\n}\n.subtitulos-viaje {\n  margin: 1.5rem 0;\n  font-size: 1.5rem;\n}\n.subtitulos-viaje span {\n  color: #f00;\n}\n.color-alerta {\n  color: #f00;\n}\n.texto-normal {\n  font-family: Helvetica;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Github/trosten/trosten-web-app/src/app/components/viaje-vista-operador/viaje.operador.styl
// module id = ../../../../../src/app/components/viaje-vista-operador/viaje.operador.styl
// module chunks = main